import React from "react"
import { Link } from "react-router-dom"

const Logo = () => {
    return (
        <React.Fragment>
            <div className="navbar-brand-box">
                <Link to="/" className="logo logo-dark">
                    <img
                        className="small-logo-image"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALUAAABWCAQAAAAjih8OAAAAhElEQVR42u3QQREAAAwCoNm/9Fp4PiACOUqiQLVqVKtGtWrVqFaNatWqUa0a1apVo1o1qlWrRrVqVKtWjWrVqFaNatWqUa0a1apVo1o1qlWrRrVqVKtWjWrVqFatGtWqUa0a1apVo1o1qlWrRrVqVKtWjWrVqFatGtWqUa1aNapVo3rVAzPMAFdJFQ7xAAAAAElFTkSuQmCC"
                        alt=""
                        height="35"
                    />
                </Link>

                <Link to="/" className="logo logo-light">
                    <img
                        className="small-logo-image"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALUAAABWCAQAAAAjih8OAAAAhElEQVR42u3QQREAAAwCoNm/9Fp4PiACOUqiQLVqVKtGtWrVqFaNatWqUa0a1apVo1o1qlWrRrVqVKtWjWrVqFaNatWqUa0a1apVo1o1qlWrRrVqVKtWjWrVqFatGtWqUa0a1apVo1o1qlWrRrVqVKtWjWrVqFatGtWqUa1aNapVo3rVAzPMAFdJFQ7xAAAAAElFTkSuQmCC"
                        alt=""
                        height="35"
                    />
                </Link>
            </div>
        </React.Fragment>
    )
}

export default Logo
